import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { DEFAULT_TITLE, staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/generator.mio'

const getClientModule = () => import('src/clientRoutes/generator.mio')

export const handle = { name: 'generator/mio' }

/**
 * SSR loader.
 * Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L421-L435
 *
 * Note: server:meta.mio keys are under "server:meta" literal key in JSON,
 * not under "meta.mio", so t('server:meta.mio.title') may not find them.
 * This matches production behavior where mio page uses default home title.
 */
export function loader({ request, context }: Route.LoaderArgs) {
  const { t, exists } = getI18n(context)
  const imageKey = 'server:meta.mio.image'
  return staticMetaLoader({
    requestUrl: request.url,
    title: DEFAULT_TITLE, // Mio page always uses DEFAULT_TITLE
    description: t('server:meta.mio.description'),
    image: exists(imageKey) ? t(imageKey) : undefined,
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
